import { setConfig } from '@tencent/iegsp-common/tools/utils/galileo';
import type { QueryUserInfoReq } from 'iegsp-api/git.woa.com/itrpcprotocol/iegsp/suppliercgi/course/course';
import { useUserStore } from '@/store';

function init(query?: QueryUserInfoReq) {
  return useUserStore()
    .getUserInfo(query)
    .then((res) => {
      const { userInfo } = useUserStore();
      if (userInfo?.name) {
        setConfig({ uid: userInfo.name });
      }
      return res;
    });
}

export { init };
